import { routes } from '../../../utils/constants/routes';

const getFirstPathSegment = (path: string) => {
  const [segment] = path.split('/').filter(Boolean);

  return segment ? `/${segment}` : '/';
};

const collectMainRouteNames = (value: unknown, result = new Set<string>()) => {
  if (typeof value === 'string') {
    result.add(getFirstPathSegment(value));

    return result;
  }

  if (value && typeof value === 'object') {
    Object.values(value).forEach((child) => collectMainRouteNames(child, result));
  }

  return result;
};

const mainRouteNames = collectMainRouteNames(routes);

const getMainRouteName = (path: string) => {
  const mainRouteName = getFirstPathSegment(path);

  return mainRouteNames.has(mainRouteName) ? mainRouteName : '/other';
};

export default getMainRouteName;
